<template>
    <div>
        <!-- 标题 -->
        <div class="BillingPage-title">
            <Row :gutter="12">
                <Col span="12">{{ $t('patch_management.patch_monitor.patchMonitor') }}</Col>
                <Col span="12">
                    <Row :gutter="4">
                        <Col span="12">
                            <!-- 按区域筛选 -->
                            <Select v-model="regionSearchKey" filterable placeholder="" :transfer="true" @on-change="changeRegionSearchKey(regionSearchKey)">
                                <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </Col>
                        <Col span="12">
                            <!--按账户筛选  -->
                            <Select v-model="accountIdSearchKey" filterable placeholder=""  @on-change="changeAccountId(accountIdSearchKey)" :transfer="true">
                                <Option :value="item.id" v-for="item in accountIdList" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
        <br>
        <!--图表 -->
        <Row :gutter="16">
            <Col span="12">
                <Card :padding="8">
                    <Row>
                        <Col span="24" class="title" style="margin-bottom: 20px;">{{ $t('patch_management.patch_monitor.instanceType') }}</Col>
                        <Col span="24">
                            <div id="pieBillingOverview" style="width:100%;height: 278px;"></div>
                        </Col>
                    </Row>
                </Card>
            </Col>

            <!-- Billing Overview -->
            <Col span="12">
                <Card :padding="8">
                    <Row>
                        <Col span="24" class="title" style="margin-bottom: 20px;">{{ $t('patch_management.patch_monitor.patchedInstancesByOS') }}</Col>
                        <Col span="24">
                            <div id="pieBillingOverviews" style="width:100%;height: 278px;"></div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
        <br>
        <Row :gutter="16">
            <Col span="24">
                <Col span="24" class="title" style="margin-bottom: 10px;">{{ $t('patch_management.patch_monitor.patchedInstance') }}</Col>
                <Table :no-data-text="$t('common.noData')" :columns="columnsCommandState" :data="commandState" style="width: 100.1%;" :loading="tableCommandLoadings"></Table>
            </Col>
        </Row>
        <br>
        <Row :gutter="16">
            <Col span="24">
                <Col span="24" class="title" style="margin-bottom: 10px;">{{ $t('patch_management.patch_monitor.notPatchedInstances') }}</Col>
                <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tableTargetInstanceDate" style="width: 100.1%;" :loading="tableTargetInstanceLoadings"></Table>
            </Col>
        </Row>
    </div>
</template>

<script>
    export default {
        name: 'SlBillingPage',
        data () {
            return {
                tableCommandLoadings: false,
                tableTargetInstanceLoadings:false,
                accountIdSearchKey:'',
                regionSearchKey:'',
                accountIdList:[],
                regionList:[],
                patchedInstancePatchPolicyPieChart:[],
                systemPolicyPieChart:[],
                chartPieBillingOverview:'',
                chartPieBillingOverviews:'',
                columns: [
                    {
                        title: this.$t('patch_management.patch_monitor.id'),
                        key: 'instanceId'
                    },
                    {
                        title: this.$t('patch_management.patch_monitor.name'),
                        key: 'instanceName'
                    }, 
                    {
                        title: this.$t('patch_management.patch_monitor.missingCount'),
                        key: 'missingCount'
                    },
                    {
                        title: this.$t('patch_management.patch_monitor.installedCount'),
                        key: 'installedCount'
                    },
                    {
                        title: this.$t('patch_management.patch_monitor.installedOtherCount'),
                        key: 'installedOtherCount'
                    },
                    {
                        title: this.$t('patch_management.patch_monitor.notApplicableCount'),
                        key: 'notApplicableCount'
                    }
                ],
                columnsCommandState: [
                    {
                        title: this.$t('patch_management.patch_monitor.id'),
                        key: 'instanceId'
                    },
                    {
                        title: this.$t('patch_management.patch_monitor.name'),
                        key: 'instanceName'
                    }, 
                    {
                        title: this.$t('patch_management.patch_monitor.missingCount'),
                        key: 'missingCount'
                    },
                    {
                        title: this.$t('patch_management.patch_monitor.installedCount'),
                        key: 'installedCount'
                    },
                    {
                        title: this.$t('patch_management.patch_monitor.installedOtherCount'),
                        key: 'installedOtherCount'
                    },
                    {
                        title: this.$t('patch_management.patch_monitor.notApplicableCount'),
                        key: 'notApplicableCount'
                    }
                ],
                tableTargetInstanceDate:[],
                commandState:[],
                newPatchedInstancePatchPolicyPieChartList:[],
                newSystemPolicyPieChartCopyList:[]
            }
        },
        mounted:function(){
            this.selectAccountByCloudPlatform();
             // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartPieBillingOverview.resize();
                self.chartPieBillingOverviews.resize();
            });
        },
        methods: {
            //查询补丁监视器
            patchMonitor: function(){
                this.tableCommandLoadings = true;
                this.tableTargetInstanceLoadings=true;
                this.$api.policy.patchMonitor({
                    "id" : this.accountIdSearchKey,
                    "region" : this.regionSearchKey
                })
                .then(res => {
                    this.tableTargetInstanceDate=res.data.noPatchedInstance;
                    this.commandState=res.data.patchedInstance;
                    // Instance Type
                    this.patchedInstancePatchPolicyPieChart=res.data.patchedInstancePatchPolicyPieChart;
                    for(var i=0;i<this.patchedInstancePatchPolicyPieChart.length;i++){
                        var PatchedInstancePatchPolicyPieChartCopy = new Object();
                        PatchedInstancePatchPolicyPieChartCopy.name = this.patchedInstancePatchPolicyPieChart[i].name;
                        this.newPatchedInstancePatchPolicyPieChartList.push(PatchedInstancePatchPolicyPieChartCopy);
                    }
                    // Patched Instances By OS
                    this.systemPolicyPieChart=res.data.systemPolicyPieChart;
                    for(var i=0;i<this.systemPolicyPieChart.length;i++){
                        var SystemPolicyPieChartCopy = new Object();
                        SystemPolicyPieChartCopy.name = this.systemPolicyPieChart[i].name;
                        this.newSystemPolicyPieChartCopyList.push(SystemPolicyPieChartCopy);
                    }
                    this.tableCommandLoadings = false;
                    this.tableTargetInstanceLoadings=false;
                    this.init();
                })
            },
            /**********************账号********************************/
            //查询账号
            selectAccountByCloudPlatform: function(){
                this.$api.account.selectAccountByCloudPlatform("type",0)
                .then(res => {
                    this.accountIdList = res.data; 
                    this.accountIdSearchKey=this.accountIdList[0].id;
                    //查询地区
                    this.$api.account.queryAccountRegions("accountId",this.accountIdSearchKey)
                        .then(res => {
                            this.regionList = res.data;
                            this.regionSearchKey=this.regionList[0].name;
                            this.patchMonitor();
                        })

                })
            },
            // 切换账号
            changeAccountId: function(){
             
                //查询地区
                this.$api.account.queryAccountRegions("accountId",this.accountIdSearchKey)
                .then(res => {
                    this.regionList = res.data;
                    this.regionSearchKey=this.regionList[0].name;
                    this.patchMonitor();
                })
            },
            //切换区域
            changeRegionSearchKey:function(){
                this.patchMonitor();
            },
            /******************所有图表*******************************************************/ 
            init:function(){
                setTimeout(()=>{
                    this.pieBillingOverviewLine();
                    this.pieBillingOverviewLines();
                })
            },
            // Billing Overview
            pieBillingOverviewLine:function(){
                this.chartPieBillingOverview=this.$echarts.init(document.getElementById("pieBillingOverview"));
                this.chartPieBillingOverview.setOption({
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c}"
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: this.newPatchedInstancePatchPolicyPieChartList
                    },
                    color:['#47bac1', '#e5c55f','#798ee1','#ccc'],
                    series : [
                        {
                            name: '数量',
                            type: 'pie',
                            radius : '70%',
                            center: ['50%', '45%'],
                            data:this.patchedInstancePatchPolicyPieChart,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                })                
            },
            // Billing Overview
            pieBillingOverviewLines:function(){
                this.chartPieBillingOverviews=this.$echarts.init(document.getElementById("pieBillingOverviews"));
                this.chartPieBillingOverviews.setOption({
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c}"
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: this.newSystemPolicyPieChartCopyList
                    },
                    color:['#798ee1','#ccc'],
                    series : [
                        {
                            name: '数量',
                            type: 'pie',
                            radius : '70%',
                            center: ['50%', '45%'],
                            data:this.systemPolicyPieChart,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                })                
            }
        }
    }
</script>

<style scoped>
    .BillingPage-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 15px;
        font-weight: 600;
    }
    .title
    {
        font-size:13px;
        font-weight: 600;
        padding: 10px;
        float:left;
        color:#000;
        margin-bottom: 0px;
    }
    /* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
</style>




// WEBPACK FOOTER //
// src/components/patch_management/patch_monitor/PatchMonitor.vue